import React from 'react';
import { RotateCcw, RotateCw } from 'lucide-react';

// Seek a native <video> or a Vimeo iframe (via its postMessage API) by delta seconds.
export function seekBy(el, delta) {
  if (!el) return;
  if (el.tagName === 'VIDEO') {
    el.currentTime = Math.max(0, (el.currentTime || 0) + delta);
    return;
  }
  const win = el.contentWindow;
  if (!win) return;
  const onMsg = (ev) => {
    let data = ev.data;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch { return; }
    }
    if (data?.method === 'getCurrentTime' && typeof data.value === 'number') {
      window.removeEventListener('message', onMsg);
      win.postMessage(JSON.stringify({ method: 'setCurrentTime', value: Math.max(0, data.value + delta) }), '*');
    }
  };
  window.addEventListener('message', onMsg);
  win.postMessage(JSON.stringify({ method: 'getCurrentTime' }), '*');
  setTimeout(() => window.removeEventListener('message', onMsg), 2500);
}

// True when the player supports our skip buttons (native file or Vimeo).
export function canSkip(kind, src) {
  return kind === 'video' || /player\.vimeo\.com/i.test(src || '');
}

const STEPS = [-10, -5, 5, 10];

export const SkipControls = ({ getTarget, className = '', testidPrefix = 'skip' }) => (
  <div className={`flex items-center justify-center gap-2 ${className}`} data-testid={`${testidPrefix}-controls`}>
    {STEPS.map((d) => (
      <button
        key={d}
        type="button"
        onClick={(e) => { e.stopPropagation(); seekBy(getTarget(), d); }}
        className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-semibold bg-white/10 hover:bg-white/20 border border-white/20 text-white transition-colors"
        data-testid={`${testidPrefix}-${d < 0 ? 'back' : 'fwd'}-${Math.abs(d)}`}
        aria-label={`${d < 0 ? 'Back' : 'Forward'} ${Math.abs(d)} seconds`}
      >
        {d < 0 ? <RotateCcw className="w-3.5 h-3.5" /> : null}
        {d < 0 ? `${d}s` : `+${d}s`}
        {d > 0 ? <RotateCw className="w-3.5 h-3.5" /> : null}
      </button>
    ))}
  </div>
);
